import { render, staticRenderFns } from "./calmModule.vue?vue&type=template&id=67bc3d58&scoped=true&"
import script from "./calmModule.vue?vue&type=script&lang=js&"
export * from "./calmModule.vue?vue&type=script&lang=js&"
import style0 from "./calmModule.vue?vue&type=style&index=0&id=67bc3d58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc3d58",
  null
  
)

export default component.exports